import { takeLatest, put, call } from 'redux-saga/effects';

import { createTrackModLog } from '../service';
import {
  CREATE_TRACK_MOD_LOG,
  CREATE_TRACK_MOD_LOG_PENDING,
  CREATE_TRACK_MOD_LOG_SUCCESS,
  CREATE_TRACK_MOD_LOG_FAILURE,
  CONFIG_SESSION
} from '@handler';
import { storage, path } from "@commons";
import { formatDateYYYYMMDDWithTime } from '@components/common/format';

function* sagaCreateTrackModLog(action) {
  yield put({ type: CREATE_TRACK_MOD_LOG_PENDING });

  try {
    const user = JSON.parse(storage.get(path.sessionUser));
    
    if (user.perfil != 'SUPORTE_AGRARE') {
      const payload = {
        module: action.module,
        functionality: action.functionality.id,
        userAuthId: user.id,
        accessDate: formatDateYYYYMMDDWithTime(new Date()),
        platform: 'CENTRAL_WEB'
      };

      yield call(createTrackModLog, payload);
    }

    yield put({ type: CREATE_TRACK_MOD_LOG_SUCCESS, registro: action.data });
  } catch (error) {
    yield put({ type: CREATE_TRACK_MOD_LOG_FAILURE, registro: action.data });
  }
}

export default function* watchCreateTrackModLog() {
  yield takeLatest(CREATE_TRACK_MOD_LOG, sagaCreateTrackModLog);
}
